<template>
  <div>
    <v-layout wrap mt-12>
      <v-flex xs6>
        <v-layout wrap justify-center>
          <v-flex xs6>        
            <h1>{{ $t('a') }}</h1>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs5 text-end pt-2>
        <invite-user-to-join-team v-if="['manager', 'admin'].includes(user.data.role)" :isButtonOutlined="true"/>
      </v-flex> -->
      <v-flex xs5 text-end pt-5>
        <small>{{ $t('abis') }}</small>
      </v-flex>
      <v-flex xs1>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs11 md10>
        <v-layout wrap v-if="!user.company.isActive" justify-center>
          <v-flex xs12 pt-4>
            <v-banner single-line color="primary" rounded>
              <div class="my-2">
                <v-layout wrap>
                  <v-flex xs1>
                    <v-avatar slot="icon" color="secondary" size="40">
                      <v-icon icon="mdi-lock" color="white">mdi-lock</v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex>
                    <span class="white--text">
                      <span>{{ $t('b') }}</span><br><small>{{ $t('c') }}</small>
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-banner>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="showTrialBanner" justify-center>
          <v-flex xs12 pt-4 mb-4>
            <v-banner single-line color="secondary" rounded>
              <div class="black--text my-1">{{ $t('d') }} {{user.company.dossiersLeftNb}} {{ user.company.dossiersLeftNb > 1 ? $t('e') : $t('eSingular') }}</div>
              <template v-slot:actions>
                <v-btn v-if="user.company.onlyDisplayedPlanIds" to="/subscribe" _target="blank" color="white"><v-icon small class="mr-2">mdi-arrow-right</v-icon> {{ $t('f') }}</v-btn>
              </template>
            </v-banner>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="showNoDossiersLeftBanner" justify-center>
          <v-flex xs12 pt-4 mb-4>
            <v-banner color="secondary" rounded class="text-center">
              <div class="black--text mt-3">
                <b>
                  <div v-if="user.company.hasOrHadSubscription">
                    <span v-if="['active', 'trialing'].includes(user.company.subscriptionStatus)">{{ $t('g') }}</span>
                    <span v-else>{{ $t('gdisabled') }}</span>
                  </div>
                  <span v-else>{{ $t('gtrial') }}</span>
                </b>
              </div>
              <div v-if="user.company.hasOrHadSubscription">
                <div v-if="user.data.role === 'admin' && (!user.company.parentCompanyId || user.data.isParentCompanyAdmin)" class="mt-4">
                  <v-btn v-if="user.company.parentCompanyId" to="/parent-company-admin-dashboard" _target="blank" color="white" class="mb-2"><v-icon small class="mr-2">mdi-arrow-right</v-icon> {{ $t('j2') }}</v-btn>
                  <v-btn v-else :to="['active', 'trialing'].includes(user.company.subscriptionStatus) ? '/edit-subscription' : '/account'" _target="blank" color="white" class="mb-2">
                    <v-icon small class="mr-2">mdi-arrow-right</v-icon>
                    <span v-if="['active', 'trialing'].includes(user.company.subscriptionStatus)">{{ $t('j') }}</span>
                    <span v-else>{{ $t('jdisabled') }}</span>
                  </v-btn>
                </div>
                <div v-else class="mt-2 mb-2">
                  <b>
                    {{ companyAdmins.length > 1 ? $t('hplural') : $t('h') }} {{ companyAdmins.map(admin => admin.email).join(', ') }}&nbsp;
                    <span v-if="['active', 'trialing'].includes(user.company.subscriptionStatus)">{{ $t('i') }}</span>
                    <span v-else>{{ $t('idisabled') }}</span>
                  </b>
                </div>
              </div>
              <div v-else>
                <div v-if="user.company.onlyDisplayedPlanIds" class="mt-4">
                  <v-btn to="/subscribe" _target="blank" color="white"><v-icon small class="mr-2">mdi-arrow-right</v-icon> {{ $t('f') }}</v-btn>
                </div>
                <div v-else>
                  <div class="mt-2">{{ $t('contactMartin') }}</div>
                  <div class="mt-1">
                    <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a>
                    <span class="ml-12">+33 6 35 36 35 48</span>
                  </div>
                </div>
              </div>
            </v-banner>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <search-dossiers/>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-12>
          <v-flex xs12 text-center>
            <v-layout wrap>
              <v-flex xs12 text-center mt-6>
                <div><img :src="images.bottom" height="180px" class="mt-12 mb-12"></div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center mb-12>
          <v-flex xs12 text-center>
            <small>
              <div><b>{{ $t('1') }}</b></div>
              <div>{{ $t('2') }}</div>
              <div>{{ $t('3') }}<br>{{ $t('4') }}</div>
            </small>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SearchDossiers from '@/components/SearchDossiers'

import { mapGetters } from "vuex";
// import InviteUserToJoinTeam from '@/components/InviteUserToJoinTeam'

export default {
  components: {
    SearchDossiers,
    // InviteUserToJoinTeam
  },
  data: () => ({
    isFetchDossiersPending: false,
    images: {
      bottom: require('@/assets/app/images/dream_flatline.svg') // kyoto_flatline.svg'),
    },
    companyAdmins: []
  }),
  mounted() {
    if (this.dossiersLeftNb === 0) {
      this.updateCompanyAdmins()
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    showTrialBanner() {
      return this.user.company && !this.showNoDossiersLeftBanner && (!this.user.company.hasOrHadSubscription) && this.user.data.companyId !== 'bx6ElUYImYMKw408BCXf' && this.user.data.companyId !== 'VqaE1YwoddDgW513x08X'
    },
    showNoDossiersLeftBanner() {
      return this.dossiersLeftNb !== null && this.dossiersLeftNb <= 0
    },
    dossiersLeftNb() {
      if (!this.user.company) return null
      return this.user.company.dossiersLeftNb
    }
  },
  methods: {
    async updateCompanyAdmins() {
      this.companyAdmins = (await this.$functions.httpsCallable('getAdminsOfMyCompany')()).data.admins
    }
  },
  watch: {
    dossiersLeftNb: {
      async handler(val, oldVal) {
        if (val === 0 && oldVal === null) {
          this.updateCompanyAdmins()
        }
      }
    }
  }
}
</script>



  


<i18n>
{
  "fr": {
    "a": "Vos dossiers",
    "abis": "Vos collègues peuvent rejoindre votre équipe en se créant un compte avec leur adresse email.",
    "b": "Notre équipe validera votre compte sous 1 jour ouvré.",
    "c": "Nous vous notifierons par mail.",
    "d": "Il reste",
    "e": "dossiers gratuits à votre équipe.",
    "eSingular": "dossier gratuit à votre équipe.",
    "f": "Choisir un abonnement",
    "g": "Votre équipe a utilisé tous les dossiers disponibles de votre abonnement mensuel.",
    "gdisabled": "Votre abonnement est désactivé",
    "gtrial": "Votre équipe a utilisé tous les dossiers gratuits de votre période d'essai.",
    "h": "Contactez votre administrateur",
    "hplural": "Contactez vos administrateurs",
    "i": "pour passer à l'abonnement supérieur.",
    "idisabled": "pour réactiver votre abonnement.",
    "j": "Voir les abonnements supérieurs",
    "jdisabled": "Gérer votre abonnement",
    "j2": "Espace administrateur du groupe",
    "k": "Vous n'avez aucun dossier.",
    "l": "Créez votre premier dossier de compétences",
    "1": "Une question ? Un feedback ?",
    "2": "Nous souhaitons construire le meilleur service pour vous.",
    "3": "Contactez-nous à martin@esnwebservices.com",
    "4": "N'hésitez pas, nous sommes là.",
    "contactMartin": "Contactez Martin pour choisir votre abonnement :"
  },
  "en": {
    "a": "Your CVs",
    "abis": "Your colleagues can join your team by creating an account with their email address.",
    "b": "Our team will validate your account within one business day.",
    "c": "You will be notified by email when your account is ready.",
    "d": "Your team has",
    "e": "free CVs left.",
    "eSingular": "free CV left.",
    "f": "Subscribe",
    "g": "Your team has used all the CVs of your monthly subscription.",
    "gdisabled": "Your subscription is disabled.",
    "gtrial": "Your team has used all the CVs of your free trial.",
    "h": "Contact your admin",
    "hplural": "Contact your admins",
    "i": "to upgrade your subscription.",
    "idisabled": "to turn your subscription back on.",
    "jdisabled": "Manage your subscription",
    "j": "See bigger plans",
    "j2": "Go to your group admin space",
    "k": "You have no CV yet.",
    "l": "Transform your first CV",
    "1": "A question ? A feedback ?",
    "2": "We want to build the best service for you.",
    "3": "Please email us at martin@esnwebservices.com",
    "4": "We'll be happy to help you.",
    "contactMartin": "Contact Martin to choose your subscription:"
  }
}
</i18n>